/**
 * API консультантской ветки.
 *
 * Во внешнюю систему продаж фронт НЕ ходит — там серверный Bearer-токен.
 * Всё через наш backend: `/api/v1/consultant/*` + `/api/v1/crm/*`.
 */
import { api } from '@/lib/api';
import type {
  ClientFieldsSummary,
  ClientsQuery,
  ConsultantClientsResponse,
  ConsultantProfile,
  OnboardResult,
} from './types';

const BASE = '/api/v1/consultant';

/**
 * ОДНА СТРАНИЦА клиентов + дерево отделов.
 *
 * Отбор, поиск и нарезка — на сервере (AK-627). Тянуть весь пул (11 244
 * записи, ~6,4 МБ) и фильтровать в браузере оказалось ровно тем, из-за чего
 * «медленно грузится и тормозит поиск».
 *
 * `refresh` — кнопка «Обновить сейчас»: обходит наш пятиминутный кэш.
 */
export const listConsultantClients = (query: ClientsQuery = {}) => {
  const p = new URLSearchParams();
  if (query.page && query.page > 1) p.set('page', String(query.page));
  if (query.perPage) p.set('per_page', String(query.perPage));
  if (query.q?.trim()) p.set('q', query.q.trim());
  if (query.node) p.set('node', query.node);
  if (query.onlyInSystem) p.set('only_in_system', 'true');
  if (query.refresh) p.set('refresh', 'true');
  const qs = p.toString();
  return api.get<ConsultantClientsResponse>(
    `${BASE}/clients${qs ? `?${qs}` : ''}`,
  );
};

/** Тип компании + открыто ли чужое окно. Нужен на каждом экране. */
export const getConsultantProfile = () =>
  api.get<ConsultantProfile>(`${BASE}/profile`);

/** «Завести в систему» прямо из строки списка. Идемпотентно по якорю. */
export const onboardExternalClient = (externalId: string) =>
  api.post<OnboardResult>(
    `${BASE}/clients/${encodeURIComponent(externalId)}/onboard`,
  );

/** Сводка полей клиента — видна ДО входа в его окно. */
export const getClientFieldsSummary = (crmCompanyId: string) =>
  api.get<ClientFieldsSummary>(
    `/api/v1/crm/companies/${crmCompanyId}/fields-summary`,
  );

/** «Вернуться к себе» — закрыть окно клиента, не дожидаясь конца часа. */
export const exitClientWindow = () =>
  api.post<{ ok: boolean }>('/api/v1/crm/exit-client');
